export enum PeriodType {
  MONTH = "MONTH",
  WEEK = "WEEK",
}
